import { datadogRum } from '@datadog/browser-rum';
import { mappedModules, ModuleTypes, ModuleTypeName } from 'utils/modules';
import Schema from 'components/shared/Schema/Schema';

export type RenderedModuleProps<K extends ModuleTypeName> = {
  module: K;
  moduleProps: ModuleTypes[K];
};

const RenderedModule = <K extends ModuleTypeName>({ module, moduleProps }: RenderedModuleProps<K>) => {
  const Module = mappedModules[module] as React.ComponentType<ModuleTypes[K]>;

  if (!Module) {
    datadogRum.addError(`${module} could not be found in the mapped modules.`);
    return null;
  }

  // Avoid fragment unless the module has schema
  if ('schema' in moduleProps && moduleProps.schema) {
    return (
      <>
        <Schema {...moduleProps.schema} />
        <Module {...(moduleProps as ModuleTypes[K])} />
      </>
    );
  }

  return <Module {...moduleProps} />;
};

export default RenderedModule;
